import styled from "styled-components";

export const FaqsWrapper = styled.div`
  overflow: hidden;

  .container {
    margin-top: 6rem;
    padding-bottom: 6rem;
  }

  .plus-icon {
    cursor: pointer;
    font-size: 18px;
    color: #fff;
    animation: fade-in 0.5s forwards;

    @keyframes fade-in {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }

  .img-fluid {
    @media (max-width: 991.98px) {
      margin-top: 4rem;
    }
  }

  .btn-div {
    margin-top: 2rem;
  }
`;

export const Title = styled.h5`
  font-size: 3.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  color: #032b88;
  text-align: center;

  @media (max-width: 990px) {
    font-size: 2rem;
  }
`;

export const ContentContainer = styled.div`
  margin-top: 4rem;
`;

export const QuestionDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 0.5px solid #fff;
`;

export const QuestionText = styled.h2`
  color: #fff;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
  margin: 0;
`;

export const AnswerText = styled.p`
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
  font-family: "Catamaran", sans-serif !important;
  animation: fade-in 0.5s forwards;

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const LeftDiv = styled.div`
  width: 80%;
  background: #032b88;
  border-radius: 1.875rem;
  padding: 2rem;
  @media (max-width: 991.98px) {
    width: 100%;
  }

  .main-dev {
    &:not(:first-child) {
      margin-top: 2rem;
    }
  }
`;

export const AnswerDiv = styled.div`
  margin-top: 1rem;
`;

export const GitBookBtn = styled.button`
  --border: 5px;
  --slant: 0.7em;
  --color: #fff;
  font-family: "Catamaran";
  font-style: normal;
  font-weight: 600;
  font-size: 21.6642px;
  text-transform: capitalize;
  padding: 0.2em 1.5em;
  /* border-radius: 4px; */
  border: none;
  cursor: pointer;
  margin-top: 2rem;
  color: #032b88;
  background: linear-gradient(90.41deg, #fff 0.34%, #fff 99.15%);
  background-repeat: no-repeat;
  box-shadow: 0 0 0 200px inset var(--s, #0000),
    0 0 0 var(--border) inset var(--color);
  clip-path: polygon(
    0 0,
    calc(100% - var(--slant)) 0,
    100% var(--slant),
    100% 100%,
    var(--slant) 100%,
    0 calc(100% - var(--slant))
  );
  transition: color var(--t, 0.3s), background-size 0.3s;
  /* display: block;
  margin-left: auto;
  margin-right: auto; */
  margin-bottom: 0rem;

  &:focus-visible {
    outline-offset: calc(-1 * var(--border));
    outline: var(--border) solid #000c;
    clip-path: none;
    background-size: 0 0;
  }
`;
